import { Children } from 'react';

const BottomLayout = ({ children }) => {
  return (
    <div
      className={`absolute z-[30] flex gap-4 flex-col bottom-5 px-2  items-center justify-center`}
    >
      {Children.map(children, (child) => child)}
    </div>
  );
};
export default BottomLayout;
